import Modal from "./Modal";
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);
var Product = function Product() {
  return new Promise(function (resolve, reject) {
    var container = document.querySelector(".js-product");
    if (!container) {
      reject();
      return;
    }
    initQuantitySwitcher();
    initColorSwitcher();
    var btnOpenModal = container.querySelector(".js-open-modal");
    var modalObj = new Modal({
      container: ".js-modal-product",
      modalOverlayCls: "js-product-overlay",
      btnCloseModal: ".js-product-close"
    });
    btnOpenModal.addEventListener("click", function (e) {
      e.preventDefault();
      modalObj.openModal();
    });
    resolve();
  });
};
function initQuantitySwitcher() {
  var container = document.querySelector(".js-product-quantity");
  if (!container) return;
  var btnPlus = container.querySelector(".js-product-quantity-plus");
  var btnMinus = container.querySelector(".js-product-quantity-minus");
  var input = container.querySelector(".js-product-quantity-input");
  var inputNumber = 1;
  input.value = inputNumber;
  if (inputNumber === 1) {
    btnMinus.classList.add("disabled");
  }
  var target = {
    inputValue: 1
  };
  var handler = {
    set: function set(item, property, value, itemProxy) {
      item[property] = value;
      input.value = value;
      if (value > 1) {
        btnMinus.classList.remove("disabled");
      }
      if (value === 1) {
        btnMinus.classList.add("disabled");
      }
      onChangeValueInput(value);
      return true;
    }
  };
  var proxy = new Proxy(target, handler);
  input.addEventListener("change", function (e) {
    inputNumber = parseInt(e.target.value);
  });
  btnPlus.addEventListener("click", function (e) {
    inputNumber += 1;
    proxy.inputValue = inputNumber;
  });
  btnMinus.addEventListener("click", function (e) {
    if (inputNumber > 1) {
      inputNumber -= 1;
      proxy.inputValue = inputNumber;
    }
  });
  function onChangeValueInput(value) {}
}
function initColorSwitcher() {
  var container = document.querySelector(".js-product-colors");
  if (!container) return;
  var activeCls = "active";
  var colorsButtons = container.querySelectorAll(".js-product-color-btn");
  if (!colorsButtons.length) return;
  colorsButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      clearAllClases();
      this.classList.add(activeCls);
      onChangeColor(this.dataset.color);
    });
  });
  function clearAllClases() {
    colorsButtons.forEach(function (btn) {
      btn.classList.remove(activeCls);
    });
  }
  function onChangeColor(color) {}
}
initProductVariations();
function initProductVariations() {
  var productId = $(".section-product__btn-wrap").attr("data-product-id");
  var defaultColor = $(".js-product-colors .color-list__item .active").attr("data-color");
  ajaxVariation(productId, defaultColor);
  ajaxAddToCart(productId, defaultColor);
  $(".js-product-colors .color-list__item").each(function () {
    var $productItem = $(this);
    $productItem.find(".js-product-color-btn").on("click", function () {
      var $productColor = $(this).attr("data-color");
      ajaxVariation(productId, $productColor);
    });
  });
  $(".section-product__btn-wrap .js-open-modal").on("click", function () {
    var productColor = $(".js-product-colors .color-list__item .active").attr("data-color");
    ajaxAddToCart(productId, productColor);
  });
}
var counter = 0;
function ajaxVariation(productId, productColor) {
  var variationData = {
    action: "productvariation",
    security: filter_params.ajax_nonce,
    color: productColor,
    productid: productId
  };
  $.ajax({
    url: filter_params.ajaxurl,
    data: variationData,
    type: "POST",
    success: function success(data) {
      if (data) {
        $(".variant-sizes").empty();
        if ($(data).filter(".callback-stock").html() == "outofstock") {
          $(".section-product__btn-wrap .btn-white").remove();
          var back_in_stock_date = $(data).filter(".callback-description").html();
          var back_in_stock_text = '<a href="#" class="btn btn--lg btn-white">Back in stock: ' + back_in_stock_date + "</a>";
          $(".section-product__btn-wrap .js-open-modal").css("display", "none");
          $(".section-product__btn-wrap").append(back_in_stock_text);
        } else {
          $(".section-product__btn-wrap .btn-white").remove();
          $(".section-product__btn-wrap .js-open-modal").css("display", "inline-block");
        }
        if ($(data).filter(".callback-variation-id").html()) {
          var productSelector = document.querySelector(".js-product");
          var prices = JSON.parse(productSelector.dataset.prices);
          var priceSelector = document.querySelector(".js-product-price");
          console.log(prices);
          priceSelector.innerHTML = prices[$(data).filter(".callback-variation-id").html()];
        }
        $(".variant-sizes").append($(data).filter(".callback-size").html());
        if ($(data).filter(".callback-images").html()) {
          var wrapper = jQuery(".js-product-images-slider .swiper-wrapper")[0];
          var slides = jQuery(wrapper).children;
          $(".js-product-images-slider .swiper-wrapper").remove();
          $(".js-product-images-slider").append('<div class="swiper-wrapper"></div>');
          $(".swiper-wrapper").append($(data).filter(".callback-images").html());
          var sliderContainer = ".js-product-images-slider";
          var instance = new Swiper(sliderContainer, {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 1,
            direction: "horizontal",
            loop: false,
            allowTouchMove: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true
            }
          });
          if (counter >= 1) {
            jQuery(".js-product-images-slider .swiper-pagination")[0].remove();
            $(".js-product-images-slider").append('<div class="swiper-pagination"></div>');
            instance.destroy(true, true);
            new Swiper(sliderContainer, {
              speed: 400,
              spaceBetween: 0,
              slidesPerView: 1,
              direction: "horizontal",
              loop: false,
              allowTouchMove: true,
              pagination: {
                el: ".swiper-pagination",
                clickable: true
              }
            });
            return;
          }
          ++counter;
        }
      }
    }
  });
}
function ajaxAddToCart(productId, productColor) {
  var quantity = $(".product-info__description .counter .counter__input").val();
  var productData = {
    action: "addtocart",
    security: filter_params.ajax_nonce,
    color: productColor,
    productid: productId,
    quantity: quantity
  };
  $.ajax({
    url: filter_params.ajaxurl,
    data: productData,
    type: "POST",
    success: function success(data) {
      if (data) {
        if ($(data).filter(".callback-price").html()) {
          $(".product-modal .product-modal__price").empty();
          $(".product-modal .product-modal__price").append($(data).filter(".callback-price").html());
        }
        if ($(data).filter(".callback-image").html()) {
          $(".product-modal .product-modal__image .product-card__image-primary").remove();
          $(".product-modal .product-modal__image").append($(data).filter(".callback-image").html());
        }
        if ($(data).filter(".callback-color").html()) {
          $(".product-modal .product-modal__color").empty();
          $(".product-modal .product-modal__color").append($(data).filter(".callback-color").html());
        }
        if ($(data).filter(".callback-cart-items").html()) {
          $(".header__right-side .cart .cart__counter").empty();
          $(".header__right-side .cart .cart__counter").append($(data).filter(".callback-cart-items").html());
          $(".product-modal .btn-primary .checkout-popup-total").empty();
          $(".product-modal .btn-primary .checkout-popup-total").append($(data).filter(".callback-cart-items").html());
        }
      }
    }
  });
}
export default Product;